<script>
  import { CalendarMonthSolid, FilterSolid } from 'flowbite-svelte-icons';
  import moment from 'moment';
  import { onMount } from 'svelte';
  import { Heading } from '@button/ui';
  import jQuery from 'jquery';
  import 'daterangepicker';
  import '../../../../node_modules/daterangepicker/daterangepicker.css';
  import Layout from '../components/Layout.svelte';
  import ReportChartClicksByOS from '../components/ReportChartClicksByOS.svelte';
  import ReportChartReferral from '../components/ReportChartReferral.svelte';
  import ReportChartTopCountries from '../components/ReportChartTopCountries.svelte';
  import ReportChartTopShortlinks from '../components/ReportChartTopShortlinks.svelte';
  import ReportChartTopCuratedShortlinks from '../components/ReportChartTopCuratedShortlinks.svelte';
  import ReportChartCuratedClicksSummary from '../components/ReportChartCuratedClicksSummary.svelte';
  import ReportChartTotalCuratedClicks from '../components/ReportChartTotalCuratedClicks.svelte';
  import ReportChartTotalClicks from '../components/ReportChartTotalClicks.svelte';
  import { queryAggCreatorStats } from '../data/aggCreatorStats';
  import { sendReportPageLoadedDebugEvent } from '../data/debug';
  import { DATE_FORMAT } from '../lib/constants';
  import { searchParams } from '../store';
  import { sendDebugEvent } from '../data/debug';
  import { _ } from 'svelte-i18n';
  import {
    Button,
    Tabs,
    TabItem,
    Input,
    Dropdown,
    DropdownItem,
  } from 'flowbite-svelte';

  window.moment = moment;

  const ALL_REFERRERS = $_('reports.filter.allReferrers', {
    default: 'All Referrers',
  });
  const DATE_RANGE_PICKER_ID = 'date-range-picker';

  let referrerDropdownOpen = false;

  function sendDebugTabVisit() {
    sendDebugEvent(`curated-visit-reports`);
  }

  onMount(() => {
    // NOTE: This needs to be cleared out when the Reports page is loaded
    $searchParams.shortlinkId = '';

    const params = new URLSearchParams(window.location.search);
    const paramsStartDate = moment(params.get('startDate'));
    const paramsEndDate = moment(params.get('endDate'));
    const startDate = paramsStartDate.isValid()
      ? paramsStartDate
      : moment().subtract(7, 'days');
    const endDate = paramsEndDate.isValid() ? paramsEndDate : moment();
    sendReportPageLoadedDebugEvent();

    $searchParams.startDate = startDate.format(DATE_FORMAT);
    $searchParams.endDate = endDate.format(DATE_FORMAT);

    jQuery(`#${DATE_RANGE_PICKER_ID}`).daterangepicker({
      startDate,
      endDate,
      maxDate: moment().endOf('day'),
      ranges: {
        [$_('managed.Reports.dateFilter.today', {
          default: 'Today',
        })]: [moment().startOf('day'), moment().endOf('day')],
        [$_('managed.Reports.dateFilter.yesterday', {
          default: 'Yesterday',
        })]: [
          moment().subtract(1, 'days').startOf('day'),
          moment().subtract(1, 'days').endOf('day'),
        ],
        [$_('managed.Reports.dateFilter.thisMonth', {
          default: 'This Month',
        })]: [
          moment().startOf('month').startOf('day'),
          moment().endOf('month').endOf('day'),
        ],
        [$_('managed.Reports.dateFilter.last7Days', {
          default: 'Last 7 Days',
        })]: [
          moment().subtract(6, 'days').startOf('day'),
          moment().endOf('day'),
        ],
        [$_('managed.Reports.dateFilter.last30Days', {
          default: 'Last 30 Days',
        })]: [
          moment().subtract(29, 'days').startOf('day'),
          moment().endOf('day'),
        ],
      },
      locale: {
        applyLabel: $_('managed.Reports.dateFilter.apply', {
          default: 'Apply',
        }),
        cancelLabel: $_('managed.Reports.dateFilter.cancel', {
          default: 'Cancel',
        }),
        customRangeLabel: $_('managed.Reports.dateFilter.customRange', {
          default: 'Custom Range',
        }),
        daysOfWeek: [
          $_('managed.Reports.dateFilter.daysOfWeek.sunday', {
            default: 'Su',
          }),
          $_('managed.Reports.dateFilter.daysOfWeek.monday', {
            default: 'Mo',
          }),
          $_('managed.Reports.dateFilter.daysOfWeek.tuesday', {
            default: 'Tu',
          }),
          $_('managed.Reports.dateFilter.daysOfWeek.wednesday', {
            default: 'We',
          }),
          $_('managed.Reports.dateFilter.daysOfWeek.thursday', {
            default: 'Th',
          }),
          $_('managed.Reports.dateFilter.daysOfWeek.friday', {
            default: 'Fr',
          }),
          $_('managed.Reports.dateFilter.daysOfWeek.saturday', {
            default: 'Sa',
          }),
        ],
        monthNames: [
          $_('managed.Reports.dateFilter.monthNames.january', {
            default: 'January',
          }),
          $_('managed.Reports.dateFilter.monthNames.february', {
            default: 'February',
          }),
          $_('managed.Reports.dateFilter.monthNames.march', {
            default: 'March',
          }),
          $_('managed.Reports.dateFilter.monthNames.april', {
            default: 'April',
          }),
          $_('managed.Reports.dateFilter.monthNames.may', {
            default: 'May',
          }),
          $_('managed.Reports.dateFilter.monthNames.june', {
            default: 'June',
          }),
          $_('managed.Reports.dateFilter.monthNames.july', {
            default: 'July',
          }),
          $_('managed.Reports.dateFilter.monthNames.august', {
            default: 'August',
          }),
          $_('managed.Reports.dateFilter.monthNames.september', {
            default: 'September',
          }),
          $_('managed.Reports.dateFilter.monthNames.october', {
            default: 'October',
          }),
          $_('managed.Reports.dateFilter.monthNames.november', {
            default: 'November',
          }),
          $_('managed.Reports.dateFilter.monthNames.december', {
            default: 'December',
          }),
        ],
      },
      buttonClasses:
        'text-center font-medium focus-within:ring-4 focus-within:outline-none inline-flex items-center justify-center px-3 py-2 text-xs text-white bg-primary-700 hover:bg-primary-800 dark:bg-primary-600 dark:hover:bg-primary-700 focus-within:ring-primary-300 dark:focus-within:ring-primary-800 rounded-lg',
    });
    jQuery(`#${DATE_RANGE_PICKER_ID}`).on(
      'apply.daterangepicker',
      (event, picker) => {
        $searchParams.startDate = picker.startDate.format(DATE_FORMAT);
        $searchParams.endDate = picker.endDate.format(DATE_FORMAT);
      },
    );
  });

  $: aggCreatorStats = queryAggCreatorStats({
    startDate: $searchParams.startDate,
    endDate: $searchParams.endDate,
  });
  $: currentData = $aggCreatorStats?.isSuccess
    ? $aggCreatorStats.data?.currentData || []
    : [];
  $: referrers = [
    ALL_REFERRERS,
    ...new Set(
      currentData
        .map((item) => item.social_platform)
        .sort((a, b) => a.localeCompare(b)),
    ),
  ];

  $: openTab = 'report-shortlink-performance';

  function handleClickReferrer(event) {
    const { innerText } = event.target;

    if (innerText === ALL_REFERRERS) {
      $searchParams.socialPlatform = undefined;

      referrerDropdownOpen = false;

      return;
    }

    $searchParams.socialPlatform = innerText;
    referrerDropdownOpen = false;
  }

  function changeTab(tabName) {
    sendDebugTabVisit();
    openTab = tabName;
  }
</script>

<Layout showCreateShortlink>
  <div class="mb-4 grid max-w-screen-xl gap-4">
    <div>
      <Heading>{$_('reports.header', { default: 'Reports' })}</Heading>
      <div class="text-gray-500">
        {$_('reports.subheader', {
          default:
            'Data is refreshed several times a day. All times are in PT.',
        })}
      </div>
    </div>
    <div
      class="col-span-2 flex flex-col justify-end gap-4 lg:col-span-1 lg:col-start-2 lg:flex-row lg:items-center"
    >
      <Button
        size="sm"
        outline
        color="light"
        class="bg-transparent text-gray-800"
        ><FilterSolid class="me-2 h-3 w-3" />{$searchParams.socialPlatform ||
          ALL_REFERRERS}</Button
      >
      <Dropdown bind:open={referrerDropdownOpen}>
        {#each referrers as referrer}
          <DropdownItem on:click={handleClickReferrer}>{referrer}</DropdownItem>
        {/each}
      </Dropdown>
      <div class="flex-1" id="datetimerange-container">
        <Input class="text-gray-800" id={DATE_RANGE_PICKER_ID} type="text">
          <CalendarMonthSolid slot="left" class="h-3 w-3 text-gray-800" />
        </Input>
      </div>
    </div>
  </div>
  <Tabs>
    <TabItem
      open={openTab === 'report-shortlink-performance'}
      title="Shortlink Performance"
      on:click={() => changeTab('report-shortlink-performance')}
    >
      <div class="w-full max-w-screen-xl">
        <div class="grid w-full grid-cols-2 gap-4">
          <div class="relative col-span-2">
            <ReportChartTotalClicks />
          </div>
          <div class="col-span-2 lg:col-span-1">
            <ReportChartTopShortlinks />
          </div>
          <div class="col-span-2 lg:col-span-1">
            <ReportChartReferral />
          </div>
          <div class="col-span-2 lg:col-span-1">
            <ReportChartClicksByOS />
          </div>
          <div class="col-span-2 lg:col-span-1">
            <ReportChartTopCountries />
          </div>
        </div>
      </div>
    </TabItem>
    <TabItem
      open={openTab === 'report-curatedby-performance'}
      title="CuratedBy Performance"
      on:click={() => changeTab('report-curatedby-performance')}
    >
      <div class="w-full max-w-screen-xl">
        <div class="grid w-full grid-cols-2 gap-4">
          <div class="relative col-span-2">
            <ReportChartTotalCuratedClicks />
          </div>
          <div class="col-span-2 lg:col-span-1">
            <ReportChartCuratedClicksSummary />
          </div>
          <div class="col-span-2 lg:col-span-1">
            <ReportChartTopCuratedShortlinks />
          </div>
        </div>
      </div>
    </TabItem>
  </Tabs>
</Layout>

<!-- eslint-disable svelte/valid-compile -->
<style global>
  .daterangepicker {
    font-family: 'Inter', sans-serif;
    border: none;
    box-shadow:
      0px 4px 6px 0px #0000000d,
      0px 10px 15px -3px #0000001a;
  }
  .daterangepicker:before,
  .daterangepicker:after {
    display: none;
  }
  .daterangepicker .ranges li.active {
    background-color: #0077ff;
  }
  .daterangepicker td.in-range {
    background-color: #b3d6ff;
    color: #000;
  }
  .daterangepicker td.active,
  .daterangepicker td.active:hover {
    background-color: #0077ff;
    color: #fff;
  }
  .daterangepicker .calendar-table thead tr:nth-child(2) {
    color: #6b7280;
  }
  .daterangepicker .calendar-table table {
    table-layout: fixed;
  }
  .daterangepicker .calendar-table table,
  .daterangepicker .calendar-table th {
    font-weight: 600;
  }
  .daterangepicker .calendar-table td {
    width: 40px;
    height: 40px;
  }
  .daterangepicker.show-calendar .drp-buttons {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 8px;
    text-align: left;
  }
  .apexcharts-legend {
    gap: 4px;
    flex-direction: column;
  }

  /* tailwind md breakpoint */
  @media (min-width: 768px) {
    .daterangepicker.show-calendar .drp-buttons {
      flex-direction: row;
      align-items: center;
    }
  }

  /* tailwind xl breakpoint */
  @media (min-width: 1280px) {
    .apexcharts-legend {
      flex-direction: row;
    }
  }
</style>
